import { type ReactNode } from 'react';

import {
  MentionChipContent,
  mentionChipClassName,
  mentionChipTitle,
} from '@/features/mention';
import { cn } from '@/lib/utils';

import { usePeopleWikiQuery } from '../people-wiki.query';

import { personToMention, renderPersonIcon } from './people-mention-source';

export const PersonMentionChip = ({
  personId,
  children,
}: {
  personId: string;
  children: ReactNode;
}) => {
  const { data: people } = usePeopleWikiQuery({ enabled: false });
  const person = people?.find(({ id }) => id === personId);
  if (!person) return <span>{children}</span>;

  const mention = personToMention(person);
  return (
    <span
      // not-prose: the message's prose styles give every img block margins, which push the avatar out of the chip
      className={cn(mentionChipClassName(), 'not-prose select-text')}
      title={mentionChipTitle(mention)}
    >
      <MentionChipContent
        mention={mention}
        icon={renderPersonIcon(mention, 'chip')}
      />
    </span>
  );
};
